module.exports = "../images/fishing-lodge-2-14.jpg?v=9a31ba0";